export const useBrowserListener = (event, listener) => {
    onBeforeMount(() => {
        if (process.server) return
        window.addEventListener(event, listener, { passive: true });
    })
    onMounted(() => {
        if (process.server) return
        listener();
    })
    onBeforeUnmount(() => {
        if (process.server) return
        window.removeEventListener(event, listener);
    })
}